module.exports = __webpack_public_path__ + "img/table_400.e12a83f5.webp";